import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllDocumentos } from "../../redux/documentos/documentosAction";
import DocumentoCard from "./documentoCard";
import "../../index.css";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { customStylesZona } from "./selectCss";

export default function InformesDocumentos() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const documentos = useSelector((state) => state.documentos.allDocumentos);
  const [documentosAux, setDocumentosAux] = useState();
  const [startDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const [dateFind, setDateFind] = useState({
    desde: new Date(),
    hasta: new Date(),
  });
  const [dateCheckbox, setDateCheckbox] = useState(false)
  const [dateError, setDateError] = useState(false)
  const [filtrarSinArmar, setFiltrarSinArmar] = useState(false)
  const [filtrarSinEntregar, setFiltrarSinEntregar] = useState(false)
  const optionsZonas = [{value:'general', label:'General'}, {value:'caba', label:'CABA'},
                        {value:'norte', label:'Norte'}, {value:'oeste', label:'Oeste'}, {value:'sur', label:'Sur'}
                       ]

  useEffect(() => {
    dispatch(getAllDocumentos());
  }, [dispatch]);

  useEffect(() => {
    if(dateFind.desde > dateFind.hasta){
      setDateError(true)
    }
  }, [dateFind]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearch = () => {
    console.log(search);    
   
        const documentosFiltrados = documentos[0].filter((e) => {
          const clienteCiudadDireccion = search ? (e.cliente ? e.cliente.nombre.toString().toLowerCase().includes(search.toLowerCase()) ||
                                                   e.cliente.ciudad.toString().toLowerCase().includes(search.toLowerCase()) ||
                                                   e.cliente.direccion.toString().toLowerCase().includes(search.toLowerCase()) : null )
                                                : true;
          const rangoFechas = dateCheckbox ? new Date(e.createdAt) >= new Date(dateFind.desde) &&
                                                                 new Date(e.createdAt) <= new Date(dateFind.hasta) : true;
          return clienteCiudadDireccion && rangoFechas;
        });
        setDocumentosAux(documentosFiltrados);
    
  };

  const handleLimpiar = () => {
    setDocumentosAux(documentos[0]);
  };


  const handleZonas = (option) => {
    //const { value } = e.target;
    console.log(option);
    
     if(option.value != "general" && filtrarSinArmar === true){
    const documentosFiltrados = documentos[0] && documentos[0].filter(
      (e) =>
        e.cliente &&
        e.cliente.zona.toString().toLowerCase().includes(option.value.toLowerCase()) && e.armado === false
    );
    setDocumentosAux(documentosFiltrados)
    } 
    else if(option.value != "general" && filtrarSinArmar === false && filtrarSinEntregar === true) {
      const documentosFiltrados = documentos[0] && documentos[0].filter(
        (e) =>
          e.cliente &&
          e.cliente.zona.toString().toLowerCase().includes(option.value.toLowerCase())  && e.armado === true && e.entregado === false
      );
      setDocumentosAux(documentosFiltrados)
    } else if(option.value != "general" && filtrarSinArmar === false && filtrarSinEntregar === false){
      const documentosFiltrados = documentos[0] && documentos[0].filter(
        (e) =>
          e.cliente &&
          e.cliente.zona.toString().toLowerCase().includes(option.value.toLowerCase())
        );
      setDocumentosAux(documentosFiltrados)
    }
    else if(option.value === "general") {
      setDocumentosAux(documentos[0])
    }
  };

  console.log(documentosAux);
  

  const handleDateDesde = (date) => {
    //console.log(date);
    setDateFind({
      ...dateFind,
      desde: date,
    });
  };
  const handleDateHasta = (date) => {
    if(dateFind.desde > date){
      setDateError(true)
      true
    } else {
    setDateFind({
      ...dateFind,
      hasta: date,
    });
    }
  };

  const handleDateCheckbox = () => {
    if(dateCheckbox){
      setDateCheckbox(false)
    } else {
      setDateCheckbox(true)
    }
    
  }

  console.log(documentos);

  return (
    <>
      <div className="bg-custom container-custom">
        <p className="text-orange-500 font-bold">Informes Documentos</p>
        <div className="h-[120px] text-orange-500 bg-gray-700">
          <div className="flex">
            {/* Barra Busqueda */}
            <div>
            <div className="flex flex-col md:flex-row md:justify-center w-[150px] pt-[10px] ml-14">
              <label className="text-[9pt] w-10 md:text-[11pt] font-bold mr-1">
                Ingresar Busqueda
              </label>
              <input
                className=" border border-slate-700 rounded w-[150px] h-[30px] text-center text-[10pt] font-semibold text-black bg-sky-200 placeholder-gray-600 md:w-[250px] md:ml-10"
                type="text"
                placeholder="Cliente - Ciudad - Direccion"
                name="search"
                onChange={handleChange}
              />
            </div>
            <div className="flex justify-around ml-[8px]  mt-4 w-[150px] border md:ml-[60px]">
            <button
              className="text-[9pt] md:text-[11pt] font-bold hover:text-orange-300"
              onClick={handleSearch}
            >
              Buscar
            </button>
            <button
              className="text-[9pt] md:text-[11pt] font-bold hover:text-orange-300"
              onClick={handleLimpiar}
            >
              Limpiar
            </button>
          </div>
            </div>
            {/*Date Picker*/}
            <div className="w-[77px] pt-[5px] ml-5 md:ml-10 md:w-[150px]">
              <div className="flex justify-center">
              <div className="font-bold text-[9pt] md:text-[11pt]">Fecha</div>
              <input 
                className="ml-2"
                type="checkbox"
                onChange={handleDateCheckbox}
              />
              </div>
              {dateCheckbox ? 
              <div className="ml-4">
              <div className="flex flex-col md:flex-row">
                <label className="text-[12px] text-yellow-500 font-bold">
                  Desde
                </label>
                <div className="w-12 text-[12px] md:pl-2">
                  <DatePicker
                    className="w-20 pl-1 rounded bg-cyan-700 text-[12px] text-yellow-400 font-bold"
                    selected={startDate}
                    onChange={handleDateDesde}
                    value={
                      dateFind.desde
                        ? format(dateFind.desde, "dd/MM/yyyy")
                        : null
                    }
                  />
                </div>
              </div>
              <div className="flex flex-col md:flex-row text-[12px] mt-1">
                <label className="text-yellow-500 font-bold">Hasta</label>
                <div className="w-12 text-[12px] md:pl-3">
                  <DatePicker
                    className="w-20 pl-1 rounded bg-cyan-700 text-[12px] text-yellow-400 font-bold"
                    selected={startDate}
                    onChange={handleDateHasta}
                    value={
                      dateFind.hasta
                        ? format(dateFind.hasta, "dd/MM/yyyy")
                        : null
                    }
                  />
                </div>
              </div>
             </div> 
             : null}
            </div>
            {/* Select Zonas */}
            <div className="w-[130px] ml-5 md:w-[200px] md:ml-12">
              <p className="text-[9pt] pt-[3px] md:text-[11pt] md:pt-[5px] font-bold">Filtrar por Zona</p>
              <div className="flex font-semibold">
              <p className="text-[9pt] md:text-[11pt]">Filtrar sin Armar</p>
              <input 
                className="ml-2"
                type="checkbox"
                onChange={!filtrarSinArmar ? ()=> setFiltrarSinArmar(true) : ()=> setFiltrarSinArmar(false) }
              />
              </div>
              <div className="flex font-semibold mb-2">
              <p className="text-[9pt] md:text-[11pt]">Filtrar sin Entregar</p>
              <input 
                className="ml-2"
                type="checkbox"
                onChange={!filtrarSinEntregar ? ()=> setFiltrarSinEntregar(true) : ()=> setFiltrarSinEntregar(false) }
              />
              </div>
              {/* <select
                className="w-[100px] ml-[9px] mt-2 rounded border bg-slate-300 text-black font-semibold text-center"
                type="text"
                name="zona"
                onChange={handleZonas}
              >
                <option value="Elegir Zona" disabled>Elegir Zona</option>
                <option value="General">General</option>
                <option value="CABA">CABA</option>
                <option value="Norte">Norte</option>
                <option value="Oeste">Oeste</option>
                <option value="Sur">Sur</option>
              </select> */}
              <Select                
                styles={customStylesZona()}
                options={optionsZonas}
                onChange={handleZonas}
              />
            </div>
          </div>

         
        </div>

        {/* Table */}
        <div>
          <div>
            <table className="">
              <thead>
                <tr className="text-orange-500 text-[12pt] font-bold border-y border-white">
                  <td className="text-[9pt] w-[60px] text-center md:w-[90px] md:text-[11pt] border">Fecha</td>
                  <td className="text-[9pt] w-[55px] text-center md:w-[80px] md:text-[11pt] border">Doc N°</td>
                  <td className="text-[9pt] w-[150px] md:w-[300px] md:text-[11pt] border">Cliente</td>
                  <td className="text-[9pt] w-[91px] hidden sm:flex md:pl-3 md:w-[100px] md:text-[11pt]">DNI / CUIT</td>
                  <td className="text-[9pt] w-[91px] md:w-[150px] md:text-[11pt] border">Ciudad</td>
                  <td className="text-[9pt] w-[110px] md:w-[300px] md:text-[11pt] border">Direccion</td>
                  <td className="text-[9pt] hidden w-[50px] sm:flex md:pl-3 md:text-[11pt]">CP</td>
                  <td className="text-[9pt] w-[45px] text-center md:text-[11pt] border">Zona</td>
                  <td className="text-[9pt] hidden w-[110px] sm:flex md:text-[11pt]">Telefono</td>
                  <td className="text-[9pt] w-[40px] md:w-[60px] md:text-[11pt] border">Armado</td>
                  <td className="text-[9pt] w-[40px] md:w-[60px] md:text-[11pt] border">Entrega</td>
                </tr>
              </thead>
            </table>
          </div>
          {documentosAux
            ? documentosAux.map((e) => (
                <DocumentoCard
                  key={e._id}
                  id={e._id}
                  numDocumento={e.numDocumento}
                  nombre={e.clienteId ? e.clienteId.nombre : e.cliente.nombre}
                  cuitCuilDni={e.clienteId ? e.clienteId.cuitCuilDni : e.cliente.cuitCuilDni}
                  ciudad={e.clienteId ? e.clienteId.ciudad : e.cliente.ciudad}
                  direccion={
                    e.clienteId ? e.clienteId.direccion : e.cliente.direccion
                  }
                  cp={e.clienteId ? e.clienteId.cp : e.cliente.cp}
                  zona={e.clienteId ? e.clienteId.zona : e.cliente.zona}
                  telefono={
                    e.clienteId ? e.clienteId.telefono : e.cliente.telefono
                  }
                  fecha={e.createdAt}
                  armado={e.armado}
                  entregado={e.entregado}
                />
              ))
            : documentos[0] &&
              documentos[0].map((e) => (
                <DocumentoCard
                  key={e._id}
                  id={e._id}
                  numDocumento={e.numDocumento}
                  nombre={e.clienteId ? e.clienteId.nombre : e.cliente.nombre}
                  cuitCuilDni={e.clienteId ? e.clienteId.cuitCuilDni : e.cliente.cuitCuilDni}
                  ciudad={e.clienteId ? e.clienteId.ciudad : e.cliente.ciudad}
                  direccion={
                    e.clienteId ? e.clienteId.direccion : e.cliente.direccion
                  }
                  cp={e.clienteId ? e.clienteId.cp : e.cliente.cp}
                  zona={e.clienteId ? e.clienteId.zona : e.cliente.zona}
                  telefono={
                    e.clienteId ? e.clienteId.telefono : e.cliente.telefono
                  }
                  fecha={e.createdAt}
                  armado={e.armado}
                  entregado={e.entregado}
                />
              ))}
        </div>
      </div>
      {/*Modales */}
      {dateError && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-gray-300 font-semibold p-4 rounded">
                        <div>"Fecha "HASTA" no puede ser menor a fecha "Desde"</div>
                        <button className="bg-blue-700 text-white mt-2 p-2 rounded hover:text-black" onClick={() => setDateError(false)}>Cerrar</button>
                    </div>
                </div>
            )}
    </>
  );
}
